export default "__VITE_ASSET__COXL5Qa0__"